import { SendMailService } from './send-mail.service';

export const sendMailService = new SendMailService();
